import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { RequestCard, RequestCardProps } from './RequestCard';
import classNames from 'classnames';

interface DraggableRequestCardProps extends RequestCardProps {
  /** Array of all selected IDs (for multi-drag) */
  selectedIds: string[];
  /** Disable dragging (e.g., for closed items) */
  dragDisabled?: boolean;
}

/**
 * DraggableRequestCard - Wrapper that makes RequestCard draggable
 * Passes selected IDs to the drag data for batch operations
 */
export const DraggableRequestCard: React.FC<DraggableRequestCardProps> = ({
  id,
  selectedIds,
  isSelected,
  dragDisabled = false,
  ...props
}) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id,
    disabled: dragDisabled,
    data: {
      // If this card is selected, drag all selected items
      // Otherwise, just drag this single item
      selectedIds: isSelected && selectedIds.length > 0 ? selectedIds : [id],
    },
  });

  const style: React.CSSProperties = {
    opacity: isDragging ? 0.5 : 1,
    cursor: dragDisabled ? 'default' : isDragging ? 'grabbing' : 'grab',
    userSelect: 'none',
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={classNames('ksq2-draggable-request-card', {
        'ksq2-draggable-request-card--dragging': isDragging,
      })}
      {...listeners}
      {...attributes}
    >
      <RequestCard id={id} isSelected={isSelected} {...props} />
    </div>
  );
};
